import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const ConnectionStatus = () => {
  const [status, setStatus] = useState('checking');
  const [lastChecked, setLastChecked] = useState(new Date());

  useEffect(() => {
    const checkConnection = () => {
      const isOnline = navigator.onLine;
      setStatus(isOnline ? 'connected' : 'disconnected');
      setLastChecked(new Date());
    };

    checkConnection();
    const interval = setInterval(checkConnection, 30000);

    window.addEventListener('online', checkConnection);
    window.addEventListener('offline', checkConnection);

    return () => {
      clearInterval(interval);
      window.removeEventListener('online', checkConnection);
      window.removeEventListener('offline', checkConnection);
    };
  }, []);

  const getStatusConfig = () => {
    switch (status) {
      case 'connected':
        return {
          icon: 'Wifi',
          color: 'var(--color-success)',
          bgColor: 'bg-success/10',
          text: 'Backend Connected',
          description: 'All systems operational'
        };
      case 'disconnected':
        return {
          icon: 'WifiOff',
          color: 'var(--color-error)',
          bgColor: 'bg-error/10',
          text: 'Connection Lost',
          description: 'Check your internet connection'
        };
      default:
        return {
          icon: 'Loader',
          color: 'var(--color-warning)',
          bgColor: 'bg-warning/10',
          text: 'Checking Connection',
          description: 'Verifying backend status'
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className={`flex items-center justify-between px-4 py-3 ${config?.bgColor} rounded-lg border border-border`}>
      <div className="flex items-center space-x-3">
        <Icon name={config?.icon} size={20} color={config?.color} strokeWidth={2} />
        <div>
          <p className="text-sm font-medium text-foreground">{config?.text}</p>
          <p className="text-xs text-muted-foreground">{config?.description}</p>
        </div>
      </div>
      <div className="text-right">
        <p className="text-xs text-muted-foreground">
          Last checked: {lastChecked?.toLocaleTimeString()}
        </p>
      </div>
    </div>
  );
};

export default ConnectionStatus;